import { createReducer, on } from '@ngrx/store';

import { IPerdidasTotales } from 'src/app/models/perdida-total/perdida-total.models';
import { borrarPerdidaTotal, cargarPerdidaTotal } from '../actions';

export {IPerdidasTotales} from 'src/app/models/perdida-total/perdida-total.models'


const initState: IPerdidasTotales = null;
const clearState: IPerdidasTotales = null;

const _perdidaTotalReducer = createReducer(initState,
  on(cargarPerdidaTotal,(state,nuevoPerdidaTotal)=>nuevoPerdidaTotal),
  on(borrarPerdidaTotal,(state)=>clearState)

);

export function perdidaTotalReducer(state: any, action: any) {
    return _perdidaTotalReducer(state, action);
}
